const QUIZ_ID_KEY = "onboarding_quiz_id"

/** Persist the funnel quiz key so webapp can read it after sessionStorage is gone. */
export function setOnboardingQuizId(id: string): void {
  try {
    window.localStorage.setItem(QUIZ_ID_KEY, id)
  } catch {
    /* ignore */
  }
}

export function getOnboardingQuizId(): string | null {
  try {
    return window.localStorage.getItem(QUIZ_ID_KEY)
  } catch {
    return null
  }
}
